import React, { useState, useRef, useEffect } from 'react';
import { selectCss } from '../styles';
import cx from 'classnames';
import DropDown from './panels/img/drop-down.svg'

const ParcelSizeSelect = ({ disabled, options, value, onChange, placeholder = 'Please select...' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const selectRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const selectedOption = options.find((opt) => opt.value === value);

    return (
        <div css={selectCss}>
            <div
                ref={selectRef}
                className={cx('custom-select-container', { 'openeq': isOpen }, { 'disable': disabled })}
            >
                <div
                    className="custom-select-header"
                    onClick={() => {
                        if (disabled) {
                            return;
                        }
                        setIsOpen(!isOpen);
                    }}
                    onKeyDown={(e) => {
                        if (disabled) {
                            return;
                        }
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            setIsOpen(!isOpen);
                        }
                    }}
                    tabIndex={disabled ? -1 : 0}
                >
                    {selectedOption ? (
                        <div className="option-content">
                            <div className="option-title">{selectedOption.title}</div>
                            {/* <div className="option-text">{selectedOption.text}</div> */}
                        </div>
                    ) : (
                        <span className="placeholder">{placeholder}</span>
                    )}
                    <DropDown />
                </div>

                <div className="custom-select-options">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`custom-option ${value === option.value ? 'selected' : ''}`}
                            onClick={() => {
                                onChange(option.value);
                                setIsOpen(false);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onChange(option.value);
                                    setIsOpen(false);
                                }
                            }}
                            tabIndex={0}
                        >
                            <div className="option-content">
                                <div className="option-title">{option.title}</div>
                                <div className="option-text">{option.text}</div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ParcelSizeSelect;
